<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <DiagCorpHeader
      v-if="!isRendering && isAdminUser && !$route.meta.isAccountEdit"
      :corpName="corporate.corpNm"
      :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
      :corporateSelectable="isAdmin || isSystemAdmin || isAllPermission"
      :manageCorpName="manageCorpName"
      :isAdmin="isAdmin"
      :isDiagAvailablePlan="isDiagAvailablePlan"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    <div class="l-contents" v-if="!isRendering">
      <h1 class="l-pageTitle">
        <span class="l-pageLabel" v-if="$route.meta.isAccountEdit">アカウント情報</span>
        <span class="l-pageLabel" v-else>法人情報</span>
        ユーザー
      </h1>
      <CorporateSideMenu :isNew=false />
      <div class="l-contentsBox l-acount-userBox">
        <div class="l-acount-userBox__menu">
          <div class="btn-create-new_wh" @click="goNew()"><a>新規作成</a></div>
          <ul class="l-userSelectList">
            <li v-for="user in this.userList" :key="user.userId" :class="{ 'is-current' : user.userId === userId }" @click="selectUser(user.userId)"><a>{{ user.nm }}</a></li>
          </ul>
        </div>
        <div class="l-acount-userBox__main">
          <div v-if="userId && !isMySelf" class="btn-userdelete js-user-delete" data-text="" @click="deleteUser()"><a><img src="@/assets/img/common/icon-x.svg" alt="">このユーザーを削除する</a></div>
          <table class="l-form-table">
            <tr>
              <th class="v-middle"><span>ユーザー名<em class="label-required">必須</em></span></th>
              <td class="v-middle">
                <div class="l-inputAccount">
                  <TextBox v-model="$v.inputForm.$model.nm" />
                  <ValidationErrorMessage v-show="$v.inputForm.nm.$error && !$v.inputForm.nm.required" validation="required" />
                </div>
              </td>
            </tr>
            <tr>
              <th class="v-middle"><span>メールアドレス<em class="label-required">必須</em></span></th>
              <td class="v-middle">
                <div class="l-inputAccount">
                  <TextBox v-model="$v.inputForm.$model.mailAddress" />
                  <ValidationErrorMessage v-show="$v.inputForm.mailAddress.$error && !$v.inputForm.mailAddress.required" validation="required" />
                  <ValidationErrorMessage v-show="$v.inputForm.mailAddress.$error && !$v.inputForm.mailAddress.email" validation="email" />
                </div>
              </td>
            </tr>
            <tr>
              <th class="v-middle"><span>電話番号</span></th>
              <td class="v-middle">
                <div class="l-inputAccount">
                  <TextBox v-model="$v.inputForm.$model.telNo" placeholder="例: 000-0000-0000" />
                  <ValidationErrorMessage v-show="$v.inputForm.telNo.$error && !$v.inputForm.telNo.maxLength" validation="maxLength" valueLength="13" />
                </div>
              </td>
            </tr>
            <tr>
              <th class="v-middle"><span>部署</span></th>
              <td class="v-middle">
                <div class="l-inputAccount">
                  <TextBox v-model="$v.inputForm.$model.dept" />
                </div>
              </td>
            </tr>
            <tr>
              <th class="v-middle"><span>ユーザー権限</span></th>
              <td class="v-middle">
                <RadioButton v-model="$v.inputForm.$model.authNo"
                  name="inputForm.corporate.prefecture_cd"
                  :options="selectAuthList"
                  :selectedValue="inputForm.authNo"
                  :disabled="!isSelectableAuthority || isMySelf"
                  ></RadioButton>
                <ValidationErrorMessage v-show="$v.inputForm.authNo.$error && !$v.inputForm.authNo.required" validation="required" />
              </td>
            </tr>
            <tr v-if="isNew">
              <th class="v-middle"><span>パスワード初期設定メール</span></th>
              <td class="v-middle">
                <label class="l-checkbox">
                  <CheckBox v-model="$v.inputForm.$model.isSendAuthRequestMail" :value="true" :checked="inputForm.isSendAuthRequestMail" labelText="送信する" />
                </label>
              </td>
            </tr>
          </table>
          <!-- 「監査表示する企業」 自分自身が社労士法人で、社労士法人のユーザ編集時のみ表示 -->
          <template v-if="selfCorpAuthNo == 3 && corporate.corpAuthNo == 3">
            <div class="l-hr"><hr></div>
            <ResponsibleCorporateInput
              :responsibleCorporates="responsibleCorporates"
              :isNew="isNew"
              @change-responsible-corporates="emitChangeResponsibleCorporates"
            ></ResponsibleCorporateInput>
          </template>
          <div class="btn-group">
            <div class="btn-basic is-inlne is-primary" @click="register()" :disabled="isProcessing"><a>保存</a></div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import RadioButton from '@/components/parts/form/RadioButton.vue';
import CheckBox from '@/components/parts/form/CheckBox.vue';
import constant from '@/const';
import { required, maxLength, email } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import CorporateSideMenu from '@/components/parts/corporate/CorporateSideMenu.vue';
import ResponsibleCorporateInput from '@/components/parts/corporate/ResponsibleCorporateInput.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';

export default {
  components: {
    Loading,
    TextBox,
    RadioButton,
    CheckBox,
    ValidationErrorMessage,
    CorporateSideMenu,
    ResponsibleCorporateInput,
    DiagCorpHeader,
  },
  data() {
    return {
      isProcessing: false,
      userList: [
        {
          userId: null,
          nm: '',
        }
      ],
      corporate: {
        corpAuthNo: 9,
        corpNm: '',
      },
      inputForm: {
        authNo: null,
        mailAddress: null,
        nm: null,
        dept: null,
        telNo: null,
        laborConsultant: false,
        diagAuthMailCc: false,
        inqMailRecvKbn: 0,
        isSendAuthRequestMail: true,
      },
      responsibleCorporateIds: [],
      responsibleCorporates: [],
      booleanList: constant.BOOLEAN_VALUE,
      inqMailRecvKbnList: constant.INQ_MAIL_RECV_KBN_VALUE,
      selfUserAuthNo: null,
      selfCorpAuthNo: null,
      selfUserId: null,
      selfCorpId: null,
      isNew: false,
      isRendering: false,
      corporateFeatureInfoLabels: [],
      isAdmin: false,
      isSystemAdmin: false,
      isAllPermission: false,
      isDiagAvailablePlan: false,
    }
  },
  validations: {
    inputForm: {
      authNo: { required },
      mailAddress: { required, email },
      nm: { required },
      dept: {  },
      telNo: { maxLength: maxLength(13) },
      laborConsultant: {  },
      diagAuthMailCc: {  },
      inqMailRecvKbn: {  },
      isSendAuthRequestMail: {  },
    }
  },
  computed: {
    corpAuthNo() {
      return this.corporate.corpAuthNo;
    },
    selectAuthList() {
      let authList = [];
      if (this.corporate.corpAuthNo != 3) {
        authList = this.$store.getters['auth/getAuthMaster'];
      } else {
        authList = this.$store.getters['auth/getAuthMasterForLaborConsultant'];
      }
      return authList.filter(authNo => {
        if (!authNo.isCorporate) return;
        if (this.corpAuthNo <= authNo.value) {
          return authNo;
        }
      });
    },
    userId() {
      return this.$store.getters['user/getUserId'];
    },
    corpId() {
      return this.$store.getters['user/getCorpId'];
    },
    isAdminUser() {
      return this.selfUserAuthNo == 3;  // 専門家ユーザのみ
    },
    isMySelf() {
      return this.userId == this.selfUserId;
    },
    isSelfCorporate() {
      return this.selfCorpId == this.corpId;
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
    isSelectableAuthority() {
      return this.selfUserAuthNo != 9;  // 一般ユーザ以外
    },
  },
  watch: {
    async corpId() {
      this.isProcessing = true;
      this.isRendering = true;

      await this.getUserList(this.corpId);
      await this.getCorporateFeatureInfoLabels(this.corpId);
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });

      await this.getUser(this.userId);
    },
  },
  created: async function() {
    this.isProcessing = true;
    this.isRendering = true;

    await this.getUserList(this.corpId);
    await this.getCorporateFeatureInfoLabels(this.corpId);
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.selfUserAuthNo = authority.userAuthNo;
    this.selfCorpAuthNo = authority.corpAuthNo;
    this.isSystemAdmin = authority.isSystemAdmin;
    this.isAllPermission = authority.isAllPermission;
    this.isAdmin = authority.isAdmin;
    this.selfUserId = authority.userId;
    this.selfCorpId = authority.corpId;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

    if (this.userList.length > 0) {
      await this.getUser(this.userList[0].userId);
    }
    this.$nextTick(() => {
      this.isRendering = false;
      this.isProcessing = false;
    });
  },
  destroyed: function() {
    // NOTE: ユーザ画面を初期表示したときに一覧のみの表示にしたいため初期化する
    this.$store.dispatch('user/setUserId', null);
  },
  methods: {
    async getUserList(corpId) {
      let res = await this.$axios.post('/ld/api/user/getUserList', {
        corpId: corpId,
      });
      if (res) {
        this.userList = res.data.userList;
        this.corporate = res.data.corporate;
      }
    },
    async selectUser(userId) {
      this.isProcessing = true;
      this.isRendering = true;

      await this.getUser(userId);
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
    async getUser(userId) {
      this.$store.dispatch('user/setUserId', userId);
      let res = await this.$axios.post('/ld/api/user/getUser', {
        userId: userId,
      });
      if (res) {
        this.inputForm = res.data.user
        this.responsibleCorporates = res.data.responsibleCorporates;
        this.isNew = (userId == null);
      }
    },
    async register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/user/store', {
          user: this.inputForm,
          responsibleCorporateIds: this.responsibleCorporateIds,
          userId: this.userId,
          corpId: this.corpId,
        });
        if (res.status === 200) {
          this.$toast.info('登録が完了しました');
          this.$v.$reset();
          await this.getUserList(this.corpId);
          this.$store.dispatch('user/setUserId', null);
          this.isProcessing = false;
          this.goNew();
        } else {
          this.$toast.error(res.data.message);
          this.isProcessing = false;
        }
      }
    },
    async getCorporateFeatureInfoLabels(corpId) {
      let res = await this.$axios.post('/ld/api/corporate/getCorporateFeatureInfoLabels', {
        corpId: corpId,
      });
      if (res) {
        this.corporateFeatureInfoLabels = res.data.corporateFeatureInfoLabels;
      }
    },
    emitChangeResponsibleCorporates(param) {
      this.responsibleCorporateIds = param.responsibleCorporateIds;
    },
    goNew() {
      this.isRendering = true;
      this.$store.dispatch('user/setUserId', null);
      this.initForm();
      this.isNew = true;
      this.$v.$reset();
      this.$nextTick(() => {
        this.isRendering = false;
      });
    },
    initForm() {
      let initialForm = {
        authNo: 9,
        mailAddress: null,
        nm: null,
        dept: null,
        telNo: null,
        laborConsultant: false,
        diagAuthMailCc: false,
        inqMailRecvKbn: 0,
        isSendAuthRequestMail: true,
      };
      this.inputForm = initialForm;
    },
    async deleteUser() {
      const ans = confirm('削除しますか？');
      if (ans) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/user/delete', {
          userId: this.userId,
        });
        if (res) {
          this.isRendering = true;
          this.$toast.info('削除しました');
          await this.getUserList(this.corpId);
          this.$store.dispatch('user/setUserId', null);
        }
        this.$nextTick(() => {
          this.isRendering = false;
          this.isProcessing = false;
        });
        this.goNew();
      }
    },
    async emitSelectCorpList(params) {
      this.$store.dispatch('user/setCorpId', params.corpId);
      this.$store.dispatch('user/setUserId', null);
    },
  }
}
</script>
